import { render, staticRenderFns } from "./AddEmployee.vue?vue&type=template&id=63de43fb&scoped=true"
import script from "./AddEmployee.vue?vue&type=script&lang=js"
export * from "./AddEmployee.vue?vue&type=script&lang=js"
import style0 from "./AddEmployee.vue?vue&type=style&index=0&id=63de43fb&scoped=true&lang=css"
import style1 from "./AddEmployee.vue?vue&type=style&index=1&id=63de43fb&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63de43fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jissjohnson/code/Zenrion/CareKraft/zenrion-erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63de43fb')) {
      api.createRecord('63de43fb', component.options)
    } else {
      api.reload('63de43fb', component.options)
    }
    module.hot.accept("./AddEmployee.vue?vue&type=template&id=63de43fb&scoped=true", function () {
      api.rerender('63de43fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/AddEmployee.vue"
export default component.exports